import { Box, Grid, Stack, Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n';
import { FunctionComponent } from 'react';
import babylonIcon from '../../assets/babylon.svg?react';
import sonicIcon from '../../assets/sonic.svg?react';
import vedaIcon from '../../assets/veda.svg?react';
import lombardIcon from '../../assets/lombard.svg?react';
import { translation } from './translation';
import { useBreakpoints } from 'modules/common/hooks/useBreakpoints';
import { BlurredStack } from 'modules/common/components/BlurredStack';

const REWARDS = [
  {
    name: 'Sonic',
    multiplier: '2-4x',
    image: sonicIcon,
    type: 'svg',
  },
  {
    name: 'Lombard',
    multiplier: '4x',
    image: lombardIcon,
    type: 'svg',
  },
  {
    name: 'Veda',
    multiplier: '3x',
    image: vedaIcon,
    type: 'svg',
  },
  {
    name: 'Babylon',
    multiplier: '1x',
    image: babylonIcon,
    type: 'svg',
  },
];

export function Rewards(): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const { isSmDown } = useBreakpoints();

  return (
    <Stack gap={2.5} mt={isSmDown ? 5 : 3}>
      <Typography variant="subtitle1" fontWeight={500}>
        {t(keys.title)}
      </Typography>

      <Grid container spacing={1.5} marginBottom={3} mt={-1.5}>
        {REWARDS.map((reward, index) => (
          <Grid xs={6} sm={6} md={6} lg={3} item key={index}>
            <BlurredStack
              key={index}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              sx={{
                borderRadius: 1.5,
                p: 1.5,
                height: '100%',
              }}
            >
              {reward.type === 'svg' ? (
                <Box
                  component={reward.image as FunctionComponent}
                  sx={{ height: 36 }}
                />
              ) : (
                <Box
                  component="img"
                  src={reward.image as unknown as string}
                  sx={{ height: 32, width: 32, borderRadius: 1 }}
                />
              )}

              <Typography variant="h7">
                {reward.name} {reward.multiplier}
              </Typography>
            </BlurredStack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
